export const taxPeriodPattern = /^(?:(?:0(?:,\d*|\.\d*)?)|(?:[1-9]|1[0-2])(?:\/(1?|12?))*)$/;
/**
 * Lodash isInteger working only with native number type
 * Important! The value passed from reduxForm is actual string, mean cannot be checked by isInteger from lodash
 * @param {string} value
 * @returns {boolean}
 */
export function isInteger(value) {
  const regex = /^\d+$/;
  return regex.test(value);
}

/**
 * Float type checking function
 * @param {string} value
 * @returns {boolean}
 */
export function isFloat(value) {
  const regex = /^[0-9]*[.][0-9]+$/;
  return regex.test(value);
}

/**
 * Check simple alphabetical characters
 * @param {string} value
 * @returns {boolean}
 */
export function isSimpleChars(value) {
  const regex = /[A-Za-zА-ЯЁа-яё]+/;
  return regex.test(value);
}

export function onlyCharsAndNumbers(value) {
  const regex = /^[A-Za-z0-9]+$/;
  return regex.test(value);
}

export function onlyCharsNumbersSymb(value) {
  const regex = /^[\w\s\(\)\/.,-]+$/;
  return regex.test(value);
}

export function onlyLettersNumbersSymb(value) {
  const regex = /^[A-Za-z0-9\s\(\)\/.,-]+$/;
  return regex.test(value);
}

export function bankName(value) {
  const regex = /^[\w\s\(\)\/.,-]+$/;
  return regex.test(value);
}

export function isFixedFloat(value, maxFloatLength = 2, allowFirstEmpty) {
  const regex = new RegExp(
    allowFirstEmpty
      ? `^([0-9]+[.]{0,1}|.{0,1})[0-9]{0,${maxFloatLength}}$`
      : `^[0-9]+[.]{0,1}[0-9]{0,${maxFloatLength}}$`,
  );
  return regex.test(value);
}

export function onlyDecimalsNumbers(value, maxFloatLength = 2) {
  const regex = new RegExp(`^[0-9]*[.,][0-9]{${maxFloatLength}}$`);
  return regex.test(value);
}

export function isYearsString(value) {
  const regex = /^\d{0,4}(?:,\d{0,4})*$/;
  return regex.test(value);
}

export function isCyrillicName(value) {
  const regex = /^[А-ЯЁа-яёIV]{1}[А-ЯЁа-яёIV.'\-\s]*$/;
  return regex.test(value);
}

export function isCyrillicMiddleName(value) {
  const regex = /^[А-ЯЁа-яё]{1}(?:[А-ЯЁа-яёIV]|\s(?!\s)|\.(?!\.|-|')|'(?!'|\.|-)|-(?!\.|-|'))*$/;
  return regex.test(value);
}

export function isOwnershipShareField(value) {
  const regex = /^(?:(?:0(?:,\d*|\.\d*)?)|(?:[1-9])\d*(?:\/?)([1-9][0-9]*)*)$/;
  return regex.test(value);
}

export function isTaxPeriodField(value) {
  return value && value <= 12;
}

export function isVin(value) {
  const regex = /^[A-HJ-NPR-Z0-9]{0,255}$/;
  return regex.test(value);
}

export function isIntOrFloat(value, maxInt, maxFloat) {
  const regex = new RegExp(
    `^(:?(:?(0|([1-9][0-9]{0,${maxInt - 1}})))|(:?(0|([1-9][0-9]{0,${
      maxInt - 1
    }}))[.,]\\d{0,${maxFloat}}))$`,
  );
  return regex.test(value);
}

export function isIntOrFloatWithDot(value, maxInt, maxFloat) {
  const regex = new RegExp(
    `^(:?(:?(0|([1-9][0-9]{0,${maxInt - 1}})))|(:?(0|([1-9][0-9]{0,${
      maxInt - 1
    }}))[.]\\d{0,${maxFloat}}))$`,
  );
  return regex.test(value);
}

/**
 * Допускаются только буквы латинского алфавита, цифры, специальные символы
 * @param value
 * @returns {boolean}
 */
export function isLatinNumberSpecials(value) {
  const regex = /^[ a-zA-Z0-9\!"`@#№\$%&'’”♣☺♂\(\)\[\]\<\>\{\}\*\+~\=_\-\.,\:;\/\|\\\^\?]*$/;
  return regex.test(value);
}

export function isRuNumberSpecials(value) {
  const regex = /^[ А-ЯЁа-яё0-9\!"`@#№\$%&'’”♣☺♂\(\)\[\]\<\>\{\}\*\+~\=_\-\.,\:;\/\|\\\^\?]*$/;
  return regex.test(value);
}
